import React from 'react';
import PropTypes from 'prop-types';
import { Attribute, Label, Value } from './Styles';

const BoxAttribute = ({ label, value, fontSize }) => {
  return (
    <Attribute>
      <Label>{label}</Label>
      <Value fontSize={fontSize}>{value}</Value>
    </Attribute>
  );
};

BoxAttribute.defaultProps = {
  fontSize: 'default',
  value: null,
};

BoxAttribute.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.any,
  fontSize: PropTypes.string,
};

export default BoxAttribute;
